<template>
  <account-layout>
    <div class="manage">
      <b-container class="pt-4">
        <b-row>
          <b-col
            :cols="12"
            :md="3"
            :lg="2">
            <management-navigation/>
          </b-col>
          <b-col
            :cols="12"
            :md="9"
            :lg="10">
            <keep-alive>
              STUFF
              <router-view/>
            </keep-alive>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </account-layout>
</template>

<script>
import ManagementNavigation from './ManagementNavigation.vue'

export default {
  name: 'Management',
  components: {
    ManagementNavigation,
  },
}
</script>
